// Tracks the last visited path that isn't part of the delivery booking flow itself,
// so flows like the Rapid Delivery "Continue Shopping" action can return the customer
// to where they actually came from even when an explicit originPath wasn't threaded
// through every entry point into /select-delivery.
const DELIVERY_FLOW_PREFIXES = ['/select-delivery', '/book-delivery', '/pre-book-delivery', '/login']

let lastPathname: string | null = null
let lastNonDeliveryFlowPath: string | null = null

const isDeliveryFlowPath = (pathname: string) =>
  DELIVERY_FLOW_PREFIXES.some((prefix) => pathname.startsWith(prefix))

export const recordVisitedPath = (path: string) => {
  if (path === lastPathname) return

  if (!isDeliveryFlowPath(path)) {
    lastNonDeliveryFlowPath = path
  }

  lastPathname = path
}

export const getLastNonDeliveryFlowPath = () => lastNonDeliveryFlowPath
